import React, { useEffect, useRef, useState } from 'react';
import { animate, timeline } from 'motion';
import { compileFilters, filter, getCounts } from './utils';

import InsightFilters from './insightFilters';
import InsightResults from './insightResults';
import SelectedFilters from '../case-studies/selectedFilters';
import { getTotalPages } from '../../helpers';

const compiledFilters = compileFilters();
const defaultCounts = getCounts(compiledFilters, window.INSIGHTS);

const index = props => {
  const { current: filters } = useRef(compiledFilters);
  const { current: STORAGE_KEY } = useRef(props.storageKey);
  const [selected, setSelected] = useState({ ...window.DEFAULT_FILTERS });
  const [count, setCount] = useState(defaultCounts);
  const [items, setItems] = useState(window.INSIGHTS);
  const [page, setPage] = useState(1);
  const totalPages = getTotalPages(items.length, Number(props.pageSize));
  const overlay = useRef(null);
  const text = useRef(null);

  const onFilterChange = (e, _selected = selected) => {
    const data = filter(e, filters, _selected);
    setSelected(data.selected);
    setCount(data.count);
    setItems(data.items);
    setPage(1);
  };

  const onLoadMore = e => {
    setPage(page + 1);
  };

  const onClear = (e, name) => {
    const clearedSelected = e
      ? {
          ...selected,
          [e]: [...window.DEFAULT_FILTERS[e]]
        }
      : {
          ...selected,
          [name]: []
        };

    const data = filter(e, filters, clearedSelected);
    setSelected(data.selected);
    setCount(data.count);
    setItems(data.items);
    setPage(1);
  };

  const onRemove = (name, value) => {
    const _e = {
      target: {
        checked: false,
        name,
        value
      }
    };
    onFilterChange(_e);
  };

  const onClearAll = () => {
    onFilterChange(
      {},
      Object.entries(window.DEFAULT_FILTERS).reduce((acc, [key]) => {
        if (!acc[key]) {
          acc[key] = [];
        }

        return acc;
      }, {})
    );
  };

  const onSave = () => {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(selected));
  };

  const getIsMobile = () => {
    return window.matchMedia('(max-width: 1024px)').matches; // this is the breakpoint set for mobile in _variables.scss
  };

  const getNumberOfElementsLeft = () => {
    const articlesLeft = items.length - page * Number(props.pageSize);
    return articlesLeft > props.pageSize ? props.pageSize : articlesLeft;
  };


  const onMouseEnter = () => {
    if (getIsMobile()) return;
    const sequence = [
      [
        text.current,
        {
          opacity: [1, 0],
          transform: ['translate(0, 0)', 'translate(100px, 0)'],
          color: '#fff'
        },
        { duration: 0.15, delay: 0.05 }
      ],
      [
        text.current,
        {
          opacity: [0, 1],
          transform: ['translate(-100px, 0)', 'translate(0, 0)']
        },
        { at: 0.17 + 0.05 },
        { duration: 0.15, delay: 0.05 }
      ]
    ];

    timeline(sequence);

    animate(
      overlay.current,
      { transform: 'scale(2, 1)' },
      { duration: 0.7 }
    ).finished.then(() => {});
  };


  const onMouseLeave = () => {
    if (getIsMobile()) return;

    const sequence = [
      [
        text.current,
        {
          opacity: [1, 0],
          transform: ['translate(0, 0)', 'translate(-100px, 0)'],
          color: '#000'
        },
        { duration: 0.15, delay: 0.05 }
      ],
      [
        text.current,
        {
          opacity: [0, 1],
          transform: ['translate(100px, 0)', 'translate(0, 0)']
        },
        { at: 0.17 + 0.05 },
        { duration: 0.15, delay: 0.05 }
      ]
    ];

    timeline(sequence);

    animate(
      overlay.current,
      { transform: 'scale(0, 1)' },
      { duration: 0.7 }
    ).finished.then(() => {});
  };

  const retreiveSelectedFilters = () => {
    const storage = window.sessionStorage.getItem(STORAGE_KEY);
    const storedFilters = storage
      ? JSON.parse(storage)
      : { ...window.DEFAULT_FILTERS };

    const filters = {
      topics: [
        ...new Set([...storedFilters.topics, ...window.DEFAULT_FILTERS.topics])
      ],
      industry: [
        ...new Set([
          ...storedFilters.industry,
          ...window.DEFAULT_FILTERS.industry
        ])
      ],
      technology: [
        ...new Set([
          ...storedFilters.technology,
          ...window.DEFAULT_FILTERS.technology
        ])
      ]
    };

    onFilterChange({}, filters);
  };

  const insightFilters = () => (
    <InsightFilters
      filters={filters}
      onChange={onFilterChange}
      selected={selected}
      count={count}
      onClear={onClear}
      onSave={onSave}
      isMobile={getIsMobile()}
    />
  );

  useEffect(() => {
    document.querySelector('.insight-results').style.minHeight = 'auto';
    retreiveSelectedFilters();
  }, []);

  return (
    <React.Fragment>
      <div className="insight-filters__container">
        <div className="insight-filters__title">
          <h2>{props.title}</h2>
          {insightFilters()}
        </div>
      </div>
      <div className="insight-filters__container-listing">
        <SelectedFilters
          sessionStorageKey={STORAGE_KEY}
          onClearAll={onClearAll}
          selected={selected}
          onRemove={onRemove}
        />
        <InsightResults items={items} page={page} pageSize={props.pageSize} />
        {page < totalPages && (
          <div className="case-studies__load-more-wrapper">
            <button
              onClick={onLoadMore}
              className="case-studies-tab__button"
              onMouseEnter={onMouseEnter}
              onMouseLeave={onMouseLeave}
            >
              <span className="overlay" ref={overlay}></span>
              <span className="text" ref={text}>
                Load {getNumberOfElementsLeft()} More Insights
              </span>
            </button>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

index.propTypes = {};

export default index;
